<template>
  <div class="phone-consulting">
    <el-row :gutter="24">
      <!-- 左侧大厅列表 -->
      <el-col :span="12">
        <div class="list-card" v-loading="publicLoading">
          <div class="card-header">
            <span class="title">大厅</span>
          </div>
          <div class="list-content">
            <div v-for="item in publicList" 
                 :key="item.id"
                 class="list-item">
              <div class="item-header">
                <div class="item-title">{{ item.cate }}</div>
                <el-button type="primary" 
                          size="mini" 
                          @click="handleTakeOrder(item)"
                          :loading="item.loading">
                  接单
                </el-button>
              </div>
              <div class="item-info">
                <div class="info-row">
                  <span>咨询人：UID{{ item.uid }}</span>
                  <span>联系电话：{{ item.phone }}</span>
                </div>
                <div class="info-row">
                  <span>下单时间：{{ item.time }}</span>
                </div>
              </div>
            </div>
            
            <!-- 分页器 -->
            <div class="pagination-container">
              <el-pagination
                background
                @size-change="handlePublicSizeChange"
                @current-change="handlePublicCurrentChange"
                :current-page="publicParams.page"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="publicParams.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="publicTotal">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 右侧我的列表 -->
      <el-col :span="12">
        <div class="list-card" v-loading="mineLoading">
          <div class="card-header">
            <span class="title">我的</span>
          </div>
          <div class="list-content">
            <div v-for="item in mineList" 
                 :key="item.id"
                 class="list-item">
              <div class="item-header">
                <div class="item-title">{{ item.cate }}</div>
                <el-button type="success" 
                          size="mini" 
                          @click="handleComplete(item)"
                          :loading="item.loading" v-if="item.status == 2">
                  完成
                </el-button>
              </div>
              <div class="item-info">
                <div class="info-row">
                  <span>咨询人：UID{{ item.uid }}</span>
                </div>
                <div class="info-row">
                  <span>联系电话：{{ item.phone }}</span>
                </div>
                <div class="info-row">
                  <span>下单时间：{{ item.time }}</span>
                </div>
                <div class="info-row" v-if="item.status !== 1">
                  <span>接单律师：{{ item.lawyer }}</span>
                </div>
                <div class="info-row" v-if="item.status == 3">
                  <span>完成时间：{{ item.dotime }}</span>
                </div>
              </div>
            </div>
            
            <!-- 分页器 -->
            <div class="pagination-container">
              <el-pagination
                background
                @size-change="handleMineSizeChange"
                @current-change="handleMineCurrentChange"
                :current-page="mineParams.page"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="mineParams.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="mineTotal">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import consultingApi from '@/api/consulting'

export default {
  name: 'PhoneConsulting',
  data() {
    return {
      // 大厅列表相关
      publicList: [],
      publicLoading: false,
      publicParams: {
        page: 1,
        pageSize: 10,
        type: 'public'
      },
      publicTotal: 0,

      // 我的列表相关
      mineList: [],
      mineLoading: false,
      mineParams: {
        page: 1,
        pageSize: 10,
        type: 'mine'
      },
      mineTotal: 0
    }
  },
  created() {
    this.fetchPublicList()
    this.fetchMineList()
  },
  methods: {
    // 获取大厅列表
    async fetchPublicList() {
      try {
        this.publicLoading = true
        const res = await consultingApi.getPhoneList(this.publicParams)
        if (res.status === 200) {
          this.publicList = res.data.list.map(item => ({...item, loading: false}))
          this.publicTotal = res.data.total
        }
      } catch (error) {
        this.$message.error('获取大厅列表失败')
      } finally {
        this.publicLoading = false
      }
    },

    // 获取我��列表
    async fetchMineList() {
      try {
        this.mineLoading = true
        const res = await consultingApi.getPhoneList(this.mineParams)
        if (res.status === 200) {
          this.mineList = res.data.list.map(item => ({...item, loading: false}))
          this.mineTotal = res.data.total
        }
      } catch (error) {
        this.$message.error('获取我的列表失败')
      } finally {
        this.mineLoading = false
      }
    },

    // 接单处理
    async handleTakeOrder(item) {
      try {
        this.$set(item, 'loading', true)
        const res = await consultingApi.takePhoneOrder({ id: item.id })
        if (res.status === 200) {
          if(res.data.st === 2){
            this.$message.error('该订单已有人接单')
            await this.fetchPublicList()
            await this.fetchMineList()
            return
          }
          this.$message.success('接单成功')
          // 刷新两个列表
          await this.fetchPublicList()
          await this.fetchMineList()
        }

        // if(res.status === 400){
        //   this.$message.error(res.msg)
        //   await this.fetchPublicList()
        //   await this.fetchMineList()
        // }
      } catch (error) {
        this.$message.error('接单失败，请重试')
      } finally {
        this.$set(item, 'loading', false)
      }

    },

    // 完成咨询
    async handleComplete(item) {
      try {
        // 添加确认弹窗
        await this.$confirm('确定要完成此次电话咨询吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        this.$set(item, 'loading', true)
        const res = await consultingApi.completePhoneConsulting({ id: item.id })
        if (res.status === 200) {
          this.$message.success('咨询已完成')
          // 刷新我的列表
          await this.fetchMineList()
        }
      } catch (error) {
        if (error !== 'cancel') { // 忽略取消操作的错误
          this.$message.error('操作失败，请重试')
          console.error('完成咨询失败:', error)
        }
      } finally {
        this.$set(item, 'loading', false)
      }
    },

    // 大厅列表分页处理
    handlePublicSizeChange(val) {
      this.publicParams.pageSize = val
      this.publicParams.page = 1
      this.fetchPublicList()
    },
    handlePublicCurrentChange(val) {
      this.publicParams.page = val
      this.fetchPublicList()
    },

    // 我的列表分页处理
    handleMineSizeChange(val) {
      this.mineParams.pageSize = val
      this.mineParams.page = 1
      this.fetchMineList()
    },
    handleMineCurrentChange(val) {
      this.mineParams.page = val
      this.fetchMineList()
    }
  }
}
</script>

<style lang="less" scoped>
.phone-consulting {
  .list-card {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    height: calc(100vh - 230px);
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .card-header {
      padding: 16px;
      font-weight: 500;
      border-bottom: 1px solid #f0f0f0;

      .title {
        font-size: 16px;
        color: #262626;
      }
    }

    .list-content {
      flex: 1;
      overflow-y: auto;
      padding: 0 16px;

      .list-item {
        padding: 16px;
        border-bottom: 1px solid #f0f0f0;
        transition: all 0.3s;

        &:hover {
          background: #f5f5f5;
        }

        .item-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;

          .item-title {
            font-weight: 500;
            font-size: 14px;
            color: #262626;
          }
        }

        .item-info {
          font-size: 13px;
          color: #666;

          .info-row {
            margin-bottom: 8px;
            display: flex;
            justify-content: space-between;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .pagination-container {
      padding: 16px;
      text-align: center;
      background: #fff;
      border-top: 1px solid #f0f0f0;
    }
  }
}
</style> 